import * as React from 'react';
import Modal from 'react-native-modal';
import GoogleMapReact, { Coords } from 'google-map-react';
import { Container, PrimaryButton } from 'src/components';
import { metrics, pixelScaler } from 'src/themes/Metrics';
import { Image, View } from 'react-native';
import { Assets } from 'src/assets';

interface CenterProps {
  center: Coords;
  zoom: number;
}

export const MapModal = ({
  onClose,
  isVisible,
  center,
  marker,
}: {
  onClose: () => void;
  isVisible: boolean;
  marker: Coords;
  center: CenterProps;
}) => {
  return (
    <Modal onBackButtonPress={onClose} onBackdropPress={onClose} isVisible={isVisible}>
      <Container
        backgroundColor="white"
        style={{
          width: '100%',
          height: pixelScaler(300),
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: metrics.borderRadius,
        }}>
        <View
          style={{
            marginTop: metrics.medium,
            width: '93%',
            flex: 1,
            borderRadius: metrics.borderRadius,
            overflow: 'hidden',
          }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: 'AIzaSyBZmtWxUbRVpAUmqzMrzEGsEZlVLaybEPI' }}
            layerTypes={['Default']}
            style={{ flex: 1 }}
            draggable={false}
            defaultCenter={center.center}
            defaultZoom={center.zoom}>
            <Image
              {...marker}
              source={Assets.DropOffPrimary}
              style={{ width: pixelScaler(24), height: pixelScaler(31) }}
            />
          </GoogleMapReact>
        </View>
        <Container width="100%" paddingVertical={metrics.large} paddingHorizontal={metrics.huge}>
          <PrimaryButton text="close" onPress={onClose} />
        </Container>
      </Container>
    </Modal>
  );
};
